import LoginPage from "@view/LoginPage";
export default LoginPage;
